"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeviceData = getDeviceData;
exports.getDeviceFile = getDeviceFile;
exports.getDevices = getDevices;
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
function getDevices() {
  return _CacheHandler.default.requestCache(function () {
    return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/consumption/v0/locations"));
  }, 'locations');
}
function getDeviceData(location, fromDate, toDate) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/consumption/v0/locations/").concat(location.locationId, "/data?from=").concat(fromDate, "&to=").concat(toDate, "&profileRole=").concat(location.profileRole, "&profileDeterminant=").concat(location.profileDeterminant));
}
function getDeviceFile(location, fromDate, toDate) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/consumption/v0/locations/").concat(location.locationId, "/excel?from=").concat(fromDate, "&to=").concat(toDate, "&profileRole=").concat(location.profileRole, "&profileDeterminant=").concat(location.profileDeterminant), {}, {
    responseType: 'arraybuffer'
  });
}